module.exports = __webpack_public_path__ + "static/media/why-soc-md-mk-stat-4.e8f5f184.png";